module.exports = __webpack_public_path__ + "img/kr-product-intl-card2-img2.881650b.png";